import script from "./BrowseItems.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowseItems.vue?vue&type=script&setup=true&lang=js"

import "./BrowseItems.vue?vue&type=style&index=0&id=1948c906&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1948c906"]])

export default __exports__